<template>
  <div v-if="isLogged && isMobileDevice" class="bottom-navigation" :class="backgroundColorClass">
    <div class="nav-container">
      <div class="nav-item" @click="navigateTo('Connections')">
        <div class="icon-wrapper">
          <Icon name="fluent:people-community-24-regular" :size="24" />
        </div>
        <span class="nav-label">Connections</span>
      </div>
      <div class="nav-item" @click="navigateTo('Apps-Academy')">
        <div class="icon-wrapper">
          <Icon name="carbon:education" :size="24" />
        </div>
        <span class="nav-label">Academy</span>
      </div>
      <div class="nav-item" @click="navigateTo('Apps-Forum')">
        <div class="icon-wrapper">
          <Icon name="carbon:email" :size="24" />
        </div>
        <span class="nav-label">Forum</span>
      </div>
      <div class="nav-item" @click="navigateTo('Apps-Chat')">
        <div class="icon-wrapper">
          <Icon name="carbon:chat" :size="24" />
        </div>
        <span class="nav-label">Chat</span>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useRouter } from 'vue-router'
import { useAuthStore } from '@/stores/auth'
import { isMobile } from '@/utils'
import Icon from '@/components/common/Icon.vue'

const router = useRouter()
const authStore = useAuthStore()

const isLogged = computed(() => authStore.isLogged)
const isMobileDevice = computed(() => isMobile())

const isDev = computed(() => import.meta.env.DEV)
const buildMode = computed(() => import.meta.env.MODE)

const backgroundColorClass = computed(() => {
  if (isDev.value) {
    return 'bg-devmode'
  }
  
  if (buildMode.value === 'development') {
    return 'bg-builddev'
  }
  
  if (buildMode.value === 'home') {
    return 'bg-buildhome'
  }
  
  return ''
})

const navigateTo = (routeName: string) => {
  router.push({ name: routeName })
}
</script>

<style lang="scss" scoped>
.bg-devmode {
  background-color: #cc0000;
}
.bg-builddev {
  background-color: #0000ab;
}
.bg-buildhome {
  background-color: #dbdb01;
}

.bottom-navigation {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  
  &:not(.bg-devmode):not(.bg-builddev):not(.bg-buildhome) {
    background-color: var(--n-color, var(--primary-color));
  }

  /* iOS Safe Area Support - Add padding for home indicator */
  padding-bottom: var(--safe-area-inset-bottom);
  padding-left: var(--safe-area-inset-left);
  padding-right: var(--safe-area-inset-right);
  height: calc(60px + var(--safe-area-inset-bottom));
  
  .nav-container {
    display: flex;
    justify-content: space-around;
    align-items: center;
    height: 100%;
    padding: 0 16px;
  }
  
  .nav-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    flex: 1;
    cursor: pointer;
    color: var(--n-text-color, #fff);
    
    .icon-wrapper {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-bottom: 4px;
    }
    
    .nav-label {
      font-size: 12px;
      line-height: 1;
    }
    
    &:active {
      opacity: 0.7;
    }
  }
}

// Adjust main content to account for bottom navigation with safe area
:deep(.n-layout-container) {
  padding-bottom: calc(60px + var(--safe-area-inset-bottom));
}
</style>
